"use client";

import { useGlobalStore } from "@/mono/store/global";
import { useMove } from "@use-gesture/react";
import { useCallback, useEffect } from "react";
import { Vector2 } from "three";
import { create } from "zustand";
import { isBrowser } from "../platform";

export const mouseState = create(() => ({
  mouse: new Vector2(),
  mouseNormalized: new Vector2(),
}));

export default function useMouseMove() {
  if (!isBrowser) return;

  const handleMouseMove = useCallback((e) => {
    let x = e.x;
    let y = e.y;
    if (e.touches) {
      x = e.touches[0].clientX;
      y = e.touches[0].clientY;
    }

    const windowSize = useGlobalStore.getState().windowSize;

    const mousePosX = -1 + (x / windowSize.width) * 2;
    const mousePosY = 1 - (y / windowSize.height) * 2;

    const currMouse = mouseState.getState().mouse;
    const currMouseNormalized = mouseState.getState().mouseNormalized;

    currMouse.set(x, y);
    currMouseNormalized.set(mousePosX, mousePosY);
    mouseState.setState({
      mouse: currMouse,
      mouseNormalized: currMouseNormalized,
    });
  }, []);

  useEffect(() => {
    const isTouchCapable = "ontouchstart" in window;
    if (isTouchCapable) {
      window.addEventListener("touchstart", handleMouseMove, false);
      window.addEventListener("touchmove", handleMouseMove, false);
    } else {
      window.addEventListener("mousemove", handleMouseMove, false);
    }

    return () => {
      if (isTouchCapable) {
        window.removeEventListener("touchstart", handleMouseMove, false);
        window.removeEventListener("touchmove", handleMouseMove, false);
      } else {
        window.removeEventListener("mousemove", handleMouseMove, false);
      }
    };
  }, []);
}
